<div class="mc-task-asset-icon-container" [ngClass]="sizeClass">
  <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-attach'"></mat-icon>
  <span *ngIf="!displayParenthesis" class="mc-task-asset-icon-count-text">{{count}}</span>
  <span *ngIf="displayParenthesis" class="mc-task-asset-icon-parenthesis-count-text">({{count}})</span>
</div>
